import {
  $SelectedPrescription,
  fetchPrescription
} from "@store/prescription-store";
import { PrescriptionItems } from "@components/prescriptions";
import { useUnit } from "effector-react";
import { useParams } from "react-router-dom";

const SinglePrescription: React.FC = () => {
  const prescription = useUnit($SelectedPrescription);
  const { id } = useParams<{ id: string }>();

  if (!prescription && id) {
    fetchPrescription({ id: +id });
    return null;
  }
  return <PrescriptionItems rows={[prescription!]} singleMode />;
};

export default SinglePrescription;
